import { style } from '@vanilla-extract/css'

const link = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
  color: 'white',
  textDecoration: 'none',
})

const image = style({
  width: 'auto',
  height: '18px',
})

export const styles = {
  link,
  image,
}
